/**
 * @fileoverview gRPC-Web generated client stub for auth.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v0.0.0
// source: auth/v1/user.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')
const proto = {};
proto.auth = {};
proto.auth.v1 = require('./user_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.auth.v1.UserServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.auth.v1.UserServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.auth.v1.InfoRequest,
 *   !proto.auth.v1.InfoResponse>}
 */
const methodDescriptor_UserService_Info = new grpc.web.MethodDescriptor(
  '/auth.v1.UserService/Info',
  grpc.web.MethodType.UNARY,
  proto.auth.v1.InfoRequest,
  proto.auth.v1.InfoResponse,
  /**
   * @param {!proto.auth.v1.InfoRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.auth.v1.InfoResponse.deserializeBinary
);


/**
 * @param {!proto.auth.v1.InfoRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.auth.v1.InfoResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.auth.v1.InfoResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.auth.v1.UserServiceClient.prototype.info =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/auth.v1.UserService/Info',
      request,
      metadata || {},
      methodDescriptor_UserService_Info,
      callback);
};


/**
 * @param {!proto.auth.v1.InfoRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.auth.v1.InfoResponse>}
 *     Promise that resolves to the response
 */
proto.auth.v1.UserServicePromiseClient.prototype.info =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/auth.v1.UserService/Info',
      request,
      metadata || {},
      methodDescriptor_UserService_Info);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.auth.v1.LogoutRequest,
 *   !proto.auth.v1.LogoutResponse>}
 */
const methodDescriptor_UserService_Logout = new grpc.web.MethodDescriptor(
  '/auth.v1.UserService/Logout',
  grpc.web.MethodType.UNARY,
  proto.auth.v1.LogoutRequest,
  proto.auth.v1.LogoutResponse,
  /**
   * @param {!proto.auth.v1.LogoutRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.auth.v1.LogoutResponse.deserializeBinary
);


/**
 * @param {!proto.auth.v1.LogoutRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.auth.v1.LogoutResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.auth.v1.LogoutResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.auth.v1.UserServiceClient.prototype.logout =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/auth.v1.UserService/Logout',
      request,
      metadata || {},
      methodDescriptor_UserService_Logout,
      callback);
};


/**
 * @param {!proto.auth.v1.LogoutRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.auth.v1.LogoutResponse>}
 *     Promise that resolves to the response
 */
proto.auth.v1.UserServicePromiseClient.prototype.logout =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/auth.v1.UserService/Logout',
      request,
      metadata || {},
      methodDescriptor_UserService_Logout);
};


module.exports = proto.auth.v1;

